export class TranslationsHelper {
	public static cspSourceTranslations: Record<string, string> = {
		applicationName: 'Source',
		invoiceNumber: 'Invoice number',
		loadInvoice: 'Load Invoice',
		category: 'Category',
		customerId: 'Customer ID',
		customerName: 'Customer',
		contractId: 'Contract ID',
		contractName: 'Contract',
		productName: 'Product',
		productCode: 'Product ID',
		productType: 'Product Type',
		unitsChange: 'Units / Change',
		effectiveDate: 'Effective Date',
		productCategory: 'Category', // product settings category column header
		productHandlingMode: 'Mode',
		productCategoryTooltip: null,
		handlingModeTooltip: null,
		defaultTooltip: 'The default Product Type for this product as determined by ApplicationLink staff.<br>Choosing the \'Default\' option will make the use this Product Type and take on any changes made to this default later.<br>Changes to the default are most likely to happen for new services that ApplicationLink has not yet been able to categorize.',
		reference: 'Reference',
		description: 'Description',
		customerPO: 'Customer PO',
		msrp: 'MSRP'
	};

	public static cspTargetTranslations: Record<string, string> = {
		applicationName: 'Target',
		customer: 'Customer',
		contract: 'Contract',
		service: 'Service',
		serviceHeader: 'Service',
		product: 'Product',
		chargeName: 'Name',
		chargeDescription: 'Description',
		contractPeriod: 'Period',
		servicePeriod: 'Period',
		catalog: 'Catalog'
	}

	public static cspfsSourceTranslations: Record<string, string> = {
		applicationName: 'Source',
		customer: 'Customer',
		customerCode: 'Code',
		customerName: 'Name',
		service: 'Service',
		serviceCode: 'Code',
		serviceName: 'Name',
		productCategory: 'Category',
		productCategoryTooltip: undefined,
		productHandlingMode: 'Mode',
		handlingModeTooltip: 'Can be used to change the way products will be shown/handled within the integration.',
		defaultTooltip: 'The default product type for this product.'
	}

	public static cspfsTargetTranslations: Record<string, string> = {
		applicationName: 'Target',
		customer: 'Customer',
		customerCode: 'Code',
		customerName: 'Name',
		service: 'Service',
		serviceCode: 'Code',
		serviceName: 'Name',
		invoiceDescription: 'Invoice Description',
		reference: 'Reference',
		invoiceDate: 'Invoice Date',
		catalog: 'Catalog',
		costUnit: 'Cost Unit'
	}
}
